"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var EmotionBreakpoint = function EmotionBreakpoint(name) {
  var mediaQuery;

  switch (name) {
    case 'desktop':
      mediaQuery = '@media (min-width: 992px)';
      break;

    case 'notDesktop':
      mediaQuery = '@media (max-width: 991px)';
      break;

    case 'tablet':
      mediaQuery = '@media (min-width: 768px) and (max-width: 991px)';
      break;

    case 'mobile':
      mediaQuery = '@media (max-width: 767px)';
      break;

    case 'notMobile':
      mediaQuery = '@media (min-width: 768px)';
      break;

    default:
      mediaQuery = '@media (min-width: 768px)';
      break;
  }

  return mediaQuery;
};

var _default = EmotionBreakpoint;
exports["default"] = _default;